<template>
  <div>
    <v-layout wrap>
      <v-flex xs9>
        <h2 style="display:table;">
          <img class="ml-2 partner-logo" style="height: 50px" src="/static/img/assets/ketshop-onTransparent.png" />
        </h2>
      </v-flex>
      <v-flex class="text-xs-right">
        <template v-if="isEdit"></template>
        <template v-else>
          <v-btn class="partner-logo" fab small outline color="primary" @click="isEdit = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <div class="form-control mb-3" v-if="isEdit">
      <div>ketshop market</div>
      <v-radio-group v-model="ketshopmarket" row hide-details>
        <v-radio :value="true" color="primary">
          <template slot="label">
            <img src="/static/img/assets/ketmarket.png" alt style="width: 100px" />
          </template>
        </v-radio>
        <v-radio :value="false" color="primary">
          <template slot="label">
            <img src="/static/img/assets/ketshop-onTransparent.png" alt style="width: 100px" />
          </template>
        </v-radio>
      </v-radio-group>
    </div>
    <div class="form-control mb-3" :class="{ 'has-error': errors.has('ketshopApiKey') }">
      <div>ketshop api key</div>
      <template v-if="isEdit">
        <input
          type="text"
          placeholder="ketshop api key"
          v-model="ketshop_api_key"
          data-vv-name="ketshopApiKey"
          :data-vv-as="$t('ketshop api key')"
        />
        <span class="text-error" v-if="errors.has('ketshopApiKey')">
          {{ errors.first('ketshopApiKey') }}
        </span>
      </template>
      <div class="primary--text" v-else>{{ ketshop_api_key ? ketshop_api_key : '-' }}</div>
    </div>
    <div class="form-control mb-3" :class="{ 'has-error': errors.has('ketshopApiSecret') }">
      <div>ketshop api secret</div>
      <template v-if="isEdit">
        <input
          type="text"
          placeholder="ketshop api secret"
          v-model="ketshop_api_secret"
          data-vv-name="ketshopApiSecret"
          :data-vv-as="$t('ketshop api secret')"
        />
        <span class="text-error" v-if="errors.has('ketshopApiSecret')">
          {{ errors.first('ketshopApiSecret') }}
        </span>
      </template>
      <div class="primary--text" v-else>{{ ketshop_api_secret ? ketshop_api_secret : '-' }}</div>
    </div>
    <div
      v-if="ketshopmarket"
      class="form-control mb-3"
      :class="{ 'has-error': errors.has('ketshopApiSecret') }"
    >
      <div class="caption">ketshop url</div>
      <template v-if="isEdit">
        <input
          type="text"
          placeholder="ketshop url"
          v-model="ketshop_api_url"
          v-validate="'required'"
          data-vv-name="ketshopUrl"
          :data-vv-as="$t('ketshop url')"
        />
        <span class="text-error" v-if="errors.has('ketshopUrl')">
          {{ errors.first('ketshopUrl') }}
        </span>
      </template>
      <div class="primary--text" v-else>{{ ketshop_api_url ? ketshop_api_url : '-' }}</div>
    </div>
    <div>
      <div>ketshop Status</div>
      <template v-if="isEdit">
        <toggle-button
          class="mt-2"
          :value="useketshop"
          :sync="true"
          :color="$vuetify.theme.success"
          @change="toggleUseKetshop"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
        />
      </template>
      <div v-else class="primary--text">
        <template v-if="useketshop">{{ $t('active') }}</template>
        <template v-else>{{ $t('inactive') }}</template>
      </div>
    </div>

    <div class="text-xs-center" v-if="isEdit">
      <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="saveEdit">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data: function() {
    return {
      isEdit: false,
      useketshop: false,
      ketshop_api_key: '',
      ketshop_api_secret: '',
      ketshop_api_url: '',
      ketshopmarket: false
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  mounted: function() {
    this.useketshop = this.selectedBot.useketshop
    this.ketshop_api_key = this.selectedBot.ketshop_api_key
    this.ketshop_api_secret = this.selectedBot.ketshop_api_secret
    this.ketshop_api_url = this.selectedBot.ketshop_api_url
    if (this.ketshop_api_url !== null) {
      this.ketshopmarket = true
    } else {
      this.ketshopmarket = false
    }
  },
  methods: {
    toggleUseKetshop: function() {
      this.useketshop = !this.useketshop
    },
    cancelEdit: function() {
      this.isEdit = false
      this.useketshop = this.selectedBot.useketshop
      this.ketshop_api_key = this.selectedBot.ketshop_api_key
      this.ketshop_api_secret = this.selectedBot.ketshop_api_secret
      this.ketshop_api_url = this.selectedBot.ketshop_api_url
      if (this.ketshop_api_url !== null) {
        this.ketshopmarket = true
      } else {
        this.ketshopmarket = false
      }
    },
    saveEdit: function() {
      var vm = this

      return new Promise((resolve, reject) => {
        vm.$validator.validateAll().then(result => {
          if (!result) {
            // do stuff if not valid.
            vm.goToErrorInput()
            reject()
            return false
          }

          vm.$store.dispatch('loading')
          var data = {
            pageid: vm.selectedBot.pageid,
            useketshop: vm.useketshop,
            ketshop_api_key: vm.ketshop_api_key,
            ketshop_api_secret: vm.ketshop_api_secret,
            ketshop_api_url: this.ketshopmarket ? vm.ketshop_api_url : null
          }
          api.saveKetshopToken(data, function(error, response) {
            if (error) {
              vm.$store.dispatch('loading')
              reject(error)
            }
            vm.isEdit = false
            if (response.data) {
              vm.$store.state.selectedBot.useketshop = response.data.useketshop
              vm.$store.state.selectedBot.ketshop_api_key = response.data.ketshop_api_key
              vm.$store.state.selectedBot.ketshop_api_secret = response.data.ketshop_api_secret
              vm.$store.state.selectedBot.ketshop_api_url = response.data.ketshop_api_url
            }
            vm.$store.dispatch('updateKetshopToken', data)
            vm.$store.dispatch('loading')
            vm.$forceUpdate()
            resolve()
          })
        })
      })
    }
  },
  watch: {
    ketshopmarket: function(newVal, oldVal) {
      const regex = /ketmarket_/g
      const found_in_key = this.ketshop_api_key.match(regex)
      const found_in_secret = this.ketshop_api_secret.match(regex)

      if (!newVal) {
        let key = this.ketshop_api_key.split('ketmarket_')
        if (key.length > 0) {
          this.ketshop_api_key = key[key.length - 1]
        }

        let secret = this.ketshop_api_secret.split('ketmarket_')
        if (secret.length > 0) {
          this.ketshop_api_secret = secret[secret.length - 1]
        }
      } else {
        if (!found_in_key)
          this.ketshop_api_key = '' + (this.ketshop_api_key ? this.ketshop_api_key : '')
        if (!found_in_secret)
          this.ketshop_api_secret = '' + (this.ketshop_api_secret ? this.ketshop_api_secret : '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.center-text-trick {
  height: 50px;
  line-height: 50px;
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/components/view/billing/KetshopSetting.vue